import { env } from "@/env";

export const APP_URL = env.VERCEL_URL
  ? `https://${env.VERCEL_URL}`
  : `http://localhost:${env.PORT ?? 3000}`;

export const PRIVACY_POLICY_URL = "https://decibel.trade/privacy-policy";
export const TERMS_OF_SERVICE_URL = "https://decibel.trade/terms-of-service";
export const DOCS_URL = "https://docs.decibel.trade";
export const REFERRAL_PROGRAM_URL = "https://docs.decibel.trade/rewards/referral-program";
export const FEEDBACK_URL = "https://feedback.decibel.trade";
export const X_HANDLE = "DecibelTrade";
export const X_URL = `https://x.com/${X_HANDLE}`;
export const DISCORD_URL = "https://discord.gg/decibel";
export const FUN_SUPPORT_URL = "https://intercom.help/funxyz/en/";

export const NEAR_INTENTS_EXPLORER_URL = "https://explorer.near-intents.org";
export const NEAR_INTENTS_TERMS_URL = "https://near.com/terms";

/**
 * The Intents explorer prefilled with an address.
 *
 * This is the only place a user can watch a cross-chain deposit while it is still in flight: 1Click
 * reports a withdrawal to us only once it has settled, so our own API has nothing to show for the
 * minutes that matter most.
 */
export const nearIntentsExplorerUrl = (address: string) =>
  `${NEAR_INTENTS_EXPLORER_URL}/?search=${encodeURIComponent(address)}`;
